<template>
  <v-row v-bind="$attrs">
    <slot></slot>
  </v-row>
</template>

<script>
export default {
  name: "AppRow"
};
</script>
